export default "__VITE_ASSET__dLY5LEk7__"